import React, { useCallback, useEffect, useState } from 'react';
import '../../../css/print.css';
import { useParams } from 'react-router-dom';
import { useAttestedPrint } from './hooks/useAttestedPrint';

export default function AttestedToPrint() {
  const { patientId, attestedId } = useParams();

  const { fetchAttestedToPrint, fetchLogo } = useAttestedPrint();
  const [attestedToPrint, setAttestedToPrint] = useState('');
  const [logo, setLogo] = useState(null);

  const getAttestedToPrint = useCallback(() => {
    // A logo fica em branco quando a clínica não tem uma cadastrada.
    const logoPromise = fetchLogo()
      .then((logoFromApi) => setLogo(logoFromApi.data))
      .catch(() => {});

    const attestedPromise = fetchAttestedToPrint(patientId, attestedId)
      .then((returnFromApi) => setAttestedToPrint(returnFromApi.data))
      .catch((returnFromApi) => {
        console.error('ops! ocorreu um erro' + returnFromApi);
      });

    return Promise.all([attestedPromise, logoPromise]);
  }, [fetchAttestedToPrint, fetchLogo, attestedId, patientId]);

  useEffect(() => {
    const handleAfterPrint = () => {
      window.close();
    };
    document.body.classList.add('printing-active');
    window.addEventListener('afterprint', handleAfterPrint);

    // Só imprime depois que os dados e a logo estiverem prontos.
    const printTimer = { current: null };
    getAttestedToPrint().finally(() => {
      printTimer.current = setTimeout(() => {
        window.print();
      }, 500);
    });

    return () => {
      clearTimeout(printTimer.current);
      window.removeEventListener('afterprint', handleAfterPrint);
    };
  }, [getAttestedToPrint]);

  const clinic = attestedToPrint.clinic;

  return (
    <div className="container d-none d-print-block">
      <div className="text-center" style={{ minHeight: '80px' }}>
        {logo ? <img src={logo} height={80} alt="" /> : null}
      </div>

      <div className="text-center mt-5">
        <h5>ATESTADO</h5>
      </div>

      <div
        className={
          attestedToPrint.tipoDeAtestadoValue === 'REPOUSO'
            ? 'd-none d-print-block mt-5'
            : 'd-print-none'
        }
      >
        <p>
          Atesto, com o fim específico de dispensa de atividades trabalhistas (ou escolares,
          judiciárias), que o (a) paciente {attestedToPrint.nomeDoPaciente} esteve sob meus cuidados
          profissionais no dia {attestedToPrint.data} devendo permanecer em repouso por{' '}
          {attestedToPrint.quantidadeDeDiasDeRepouso} dia(s).
        </p>
      </div>

      <div
        className={
          attestedToPrint.tipoDeAtestadoValue === 'COMPARECIMENTO'
            ? 'd-none d-print-block mt-5'
            : 'd-print-none'
        }
      >
        <p>
          Atesto, com o fim específico de dispensa de atividades trabalhistas (ou escolares,
          judiciárias), que o (a) paciente {attestedToPrint.nomeDoPaciente} esteve sob meus cuidados
          profissionais no dia {attestedToPrint.data}, no período de {attestedToPrint.horaInicial}{' '}
          horas às {attestedToPrint.horaFinal} horas.
        </p>
      </div>

      <div className="text-center mt-5">
        <p>Atenciosamente,</p>
        <p>{attestedToPrint.nomeDoDentista}</p>
      </div>

      <div className="text-center mt-5">
        {attestedToPrint.cid ? (
          <>
            <p>Autorização</p>
            <p>Eu, ___________________________________________</p>
            <p>autorizo que meu diagnóstico(CID) esteja presente nesse atestado.</p>
            <p>CID: {attestedToPrint.cid}</p>
          </>
        ) : (
          <p>___________________________________________</p>
        )}
      </div>

      {clinic ? (
        <div className="text-end mt-5">
          <p className="fs--1 mb-0">{clinic.name}</p>
          <p className="fs--1 mb-0">{clinic.address}</p>
          <p className="fs--1 mb-0">{clinic.city}</p>
          <p className="fs--1 mb-0">{clinic.phone}</p>
        </div>
      ) : null}
    </div>
  );
}
